export default "__VITE_ASSET__B$u3UbWb__"